export default [
  {
    path: '/rental/report/MY_009/home_rental_charges',
    name: 'MY_009_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_009_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_009/income_develop',
    name: 'MY_009_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_009_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_009/rental_charges',
    name: 'MY_009_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_009_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_009/income_others',
    name: 'MY_009_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_009_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_009/balance_due_home_rental',
    name: 'MY_009_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_009_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
